module.exports = __webpack_public_path__ + "media/images/fit_5-de40a7799358c7cc182dfb8335508d96.png";